module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header'), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box card-box-full"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": "login"
    }
  }, [_c('p', {
    staticClass: "sp-app-default-color",
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bolder"
    }
  }, [_vm._v("Log into your account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-offset-5",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', {}, [_vm._v("Email or Phone or Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "name": "Email",
      "title": "Enter Email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group wnf-fl-form-group"
  }, [_c('label', {}, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "password",
      "name": "password",
      "title": "Enter password",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn wnf-button",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0)])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticStyle: {
      "color": "#777777"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Forgot Password?")]), _vm._v(" or "), _c('a', {
    staticStyle: {
      "color": "#888888"
    },
    attrs: {
      "href": "/register"
    }
  }, [_vm._v("Register?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42f9be46"}!./src/pages/Login/template.html
// module id = 448
// module chunks = 0